var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.iconClass,style:(_vm.iconStyle),on:{"mouseover":function($event){_vm.isHovered = true},"mouseout":function($event){_vm.isHovered = false}}})
}
var staticRenderFns = []

export { render, staticRenderFns }